<template>
	<qvoFootnote
        appLogoFileName="ARIA-full.svg"
        appReleaseNotesPath="https://confluence.quavo.com/display/ARIA/ARIA+" 
    />
</template>

<script>
	/**
	 * @fileoverview footnote.vue displays a footnote using the qvoFootnote component.
	 * It relies on the qux-common code.
	 * 
	 * @components
	 * 		qvoFootnote - footnote component from the common code
	 * 
	 * @author David Barnett <david.barnett@quavo.com>
	 */
	import qvoFootnote from '@/qux-common/components/footnote.vue';

	export default {
		name: 'footnote',
		components: {
			qvoFootnote
		}
	}
</script>